import { Component, Inject, OnInit, OnDestroy } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { v4 as uuidv4 } from 'uuid';
import { SystemInfoService } from '../../../services/system-info.service';
import { Subscription } from 'rxjs';
import { KundeKortService } from '../../../services/kunde-kort.service';
import { KundekortInfoPopup } from '../../kunde-kort/kunde-kort-popup/kunde-kort-info-popup';
import { AuthService } from '../../../services/auth.service';
import { EmailService } from '../../../services/email.service';
import { NotificationService } from '../../../shared/notification.service';
import moment from 'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Component({
  selector: 'psystem-info-popup',
  templateUrl: './system-info-popup.html',
  styleUrls: ['./system-info-popup.css']
})
export class SystemInfoPopup implements OnInit, OnDestroy {
  configForm: FormGroup;
  contactsForm: FormGroup;
  notaterForm: FormGroup;
  attachments: { name: string; url: string }[] = [];
  savedNotater: any[] = [];
  uploadProgress = 0;
  existingContacts: Array<{ id: string, name: string, phone: string, email: string }> = [];

  private subs: Subscription[] = [];
  allKunder: any[] = [];
  connectedKunder: any[] = [];
  selectedKunder: any[] = [];
  kunderSearchTerm = '';
  currentUserEmail: string = null;

  constructor(
    private storage: AngularFireStorage,
    private kundeKortService: KundeKortService,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private systemInfoService: SystemInfoService,
    private auth: AuthService,
    private emailService: EmailService,
    private notifier: NotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<SystemInfoPopup>
  ) { }

  ngOnInit() {
    const userSub = this.auth.user$.subscribe(u => this.currentUserEmail = u?.email || null);
    this.subs.push(userSub);
    this.initForms();
    this.loadInitialData();
    this.loadNotes();
    this.loadAllKunder();
    this.loadConnectedKunder();
  }

  private initForms() {
    this.configForm = this.fb.group({
      active: [this.data.active, Validators.required],
      isOrderProcessing: [this.data.isOrderProcessing],
      isNewLogoActive: [this.data.isNewLogoActive],
      needLogin: [this.data.needLogin],
      systemId: [this.data.systemId, Validators.required],
      defaultCustomerNumber: [this.data.defaultCustomerNumber],
      ip: [this.data.ip, [Validators.required, Validators.pattern(/^((25[0-5]|2[0-4]\d|[01]?\d?\d)(\.|$)){4}$/)]],
      unavailableMessage: [this.data.unavailableMessage],
      siteId: [this.data.siteId, Validators.required],
      description: [this.data.description, Validators.required],
      lockerId: [this.data.lockerId],
      isCreditActive: [this.data.isCreditActive],
      windowMessage: [this.data.windowMessage],
      vippsType: [this.data.vippsType, Validators.required],
      ipAddress: [this.data.ipAddress, Validators.required],
      vmachine: [this.data.vmachine],
      locker: [this.data.locker],
      port: [this.data.port, [Validators.required, Validators.pattern(/^\d+$/)]],
      maxThresholdTemp: [this.data.maxThresholdTemp, Validators.required],
      minThresholdTemp: [this.data.minThresholdTemp, Validators.required],
      companyId: [this.data.companyId, Validators.required],
      name: [this.data.name, Validators.required],
      controllerVersion: [this.data.controllerVersion],
      number: [this.data.number, Validators.required],
      kantineAvailble: [this.data.kantineAvailble],
      subsidy: [this.data.subsidy],
      garantiomsetning: [this.data.garantiomsetning],
      checkStatus: [this.data.checkStatus],
      isCardActive: [this.data.isCardActive],
      isGuestModeActive: [this.data.isGuestModeActive],
      isVegeterianLogoActive: [this.data.isVegeterianLogoActive],
      isHalalLogoActive: [this.data.isHalalLogoActive],
      isGroupSubsidyActive: [this.data.isGroupSubsidyActive],
      isVippsActive: [this.data.isVippsActive],
      emailsForStockFiller: [this.data.emailsForStockFiller],
      emailsForFault: [this.data.emailsForFault],
      storageId: [this.data.storageId],
      applyChangesCallbackRef: [this.data.applyChangesCallbackRef],
      generateMapping: [this.data.generateMapping],
      dbid: [this.data.dbid]
    });

    this.contactsForm = this.fb.group(
      {
        contactPersons: this.fb.array([])
      }
    );

    this.notaterForm = this.fb.group({
      text: ['', Validators.required],
      noteDate: [new Date(), Validators.required],
      reminderDate: [null],
      reminderTime: ['12:00']
    });

    if (!this.data.contactPersons || this.data.contactPersons.length === 0) {
      this.addContactPerson();
    }

    // 2. Load them on init
    this.systemInfoService.getContacts(this.data.systemId)
      .subscribe(list => this.existingContacts = list as Array<any>);
  }
  

  private loadInitialData() {
    const attSub = this.systemInfoService.getAttachments(this.data.systemId)
      .subscribe(attachments => {
        this.attachments = attachments.map(att => ({ name: att['name'], url: att['url'] }));
      });

  }

  get contactPersons(): FormArray {
    return this.contactsForm.get('contactPersons') as FormArray;
  }

  addContactPerson() {
    this.contactPersons.push(
      this.fb.group({
        name: ['', Validators.required],
        phone: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        company: ['', Validators.required],
        designation: ['', Validators.required]
      })
    );
  }

  removeContactPerson(index: number) {
    this.contactPersons.removeAt(index);
  }


showConnectedKunder(id) {

    
    this.dialog.open(KundekortInfoPopup, {
      width: '95vw',
      maxWidth: '1440px',
      height: '92vh',
      data: {
        kundekortId:id,
      }
    });

  }

  updateConfig() {
    if (this.configForm.invalid) {
      this.configForm.markAllAsTouched();
      return;
    }
    const configData = this.configForm.value;
    // this.systemInfoService.updateConfig(configData)
    // .then(() => console.log('Config updated successfully'))
    // .catch(err => console.error('Error updating config', err));
  }

  saveContacts() {
    if (this.contactsForm.invalid) {
      this.contactsForm.markAllAsTouched();
      return;
    }
    const contacts = this.contactsForm.value.contactPersons;
    console.log(contacts);
    contacts.forEach(contact => {
      this.systemInfoService.saveContacts({ systemId: this.data.systemId, ...contact })
        .catch(err => console.error('Error saving contact', err));
    });
    console.log('Contacts saved');
  }

  saveNote() {
    if (this.notaterForm.invalid) {
      this.notaterForm.markAllAsTouched();
      return;
    }
    const { reminderTime, ...formValue } = this.notaterForm.value;
    if (formValue.reminderDate && reminderTime) {
      const [hour, minute] = reminderTime.split(':').map(Number);
      formValue.reminderDate = moment(formValue.reminderDate).set({ hour, minute, second: 0, millisecond: 0 }).toDate();
    }

    const note = { systemId: this.data.systemId, ...formValue, createdAt: new Date() };
    this.systemInfoService.saveNotes(note)
      .then(() => {
        console.log('Note saved successfully');
        this.scheduleReminderEmail(note);
      });
    this.notaterForm.reset({ noteDate: new Date(), reminderDate: null, reminderTime: '12:00' });
  }

  private scheduleReminderEmail(note: any): void {
    if (!note.reminderDate || !this.currentUserEmail) return;
    const systemLabel = this.data.name || this.data.systemId || 'System';
    this.emailService.sendEmail({
      emailTo: this.currentUserEmail,
      subject: `Påminnelse: ${systemLabel}`,
      title: '',
      html: '',
      text: `Påminnelse for ${systemLabel}:\n\n${note.text}`,
      includeSignature: true,
      signatureType: 'frigg',
      asap: false,
      sendAtUnix: moment(note.reminderDate).unix(),
      attachments: [],
    }).catch(err => {
      console.error('Error scheduling reminder email', err);
      const pastDate = err?.message === 'Send time must be in the future';
      this.notifier.showNotification('error', pastDate
        ? 'Notat lagret, men påminnelsen ble ikke planlagt — datoen er allerede passert'
        : 'Notat lagret, men påminnelsen kunne ikke planlegges');
    });
  }

  private loadNotes() {
    if (!this.data.systemId) return;
    const notesSub = this.systemInfoService.getNotes(this.data.systemId)
      .subscribe(notes => this.savedNotater = notes);
    this.subs.push(notesSub);
  }

  onFileSelected(event: any) {
    const files: FileList = event.target.files;
    Array.from(files).forEach(file => {
      const filePath = `attachments/${uuidv4()}_${file.name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, file);

      task.percentageChanges().subscribe(progress => this.uploadProgress = progress ?? 0);

      task.snapshotChanges().pipe(finalize(() => {
        fileRef.getDownloadURL().subscribe(url => {
          this.attachments.push({ name: file.name, url });
          this.uploadProgress = 0;
        });
      })).subscribe();
    });
  }

  saveAttachments() {
    if (!this.attachments.length) return;
    this.attachments.forEach(att => {
      this.systemInfoService.saveAttachments({ systemId: this.data.systemId, name: att.name, url: att.url })
        .catch(err => console.error('Error saving attachment', err));
    });
    console.log('Attachments metadata saved');
  }

  onNoClick() {
    this.dialogRef.close();
  }

  private loadAllKunder() {
    // fetch all customers for the dropdown
    this.kundeKortService.getCustomers().subscribe(list => {
      this.allKunder = list;
    });
  }

  private loadConnectedKunder() {
    // fetch only those linked to this.data.systemId
    this.kundeKortService.getKunderById(this.data.systemId)
      .subscribe(list => {
        this.connectedKunder = list.map(id => {
          return { ...this.allKunder.find(kunde => kunde.kundekortId == id['kundekortId']), ...id }
        })

      });
  }

  addSelectedKunder(kundekortId) {
    // save each selected to the backend, then reload connected list


    this.kundeKortService.addSystemKunde(this.data.systemId, kundekortId).then(() => {
      this.selectedKunder = [];
      this.loadConnectedKunder();
    });
  }

  removeConnectedKunde(id) {
    this.kundeKortService.removeSystemKunde(id)
      .then(() => this.loadConnectedKunder());
  }
  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}